import { Button, Typography } from '@themenu/design-system'
import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { redirectToUrl } from '../../../utils/location'
import { ActivationStepLayout } from './ActivationStepLayout'
import { Confetti } from './Confetti'

/**
 * Terminal success screen. Finalize has issued the directory JWT; the
 * post-activation destination is FE-owned (contract §12) and resolved by
 * `activationRedirectUrl` upstream in `ActivationFlow` (origin || EMPLOYEE_APP_URL,
 * never null — BR users are always employees). The user exits the flow manually
 * via the continue button; there is no automatic redirect.
 */
export type SuccessStepProps = {
  redirectUrl: string
}

export const SuccessStep: FC<SuccessStepProps> = ({ redirectUrl }) => {
  const { formatMessage } = useIntl()

  return (
    <>
    <Confetti />
    <ActivationStepLayout
      titleId="br_activation.success.title"
      testId="br-activation-success"
      centered
      footer={
        <Button
          data-testid="br-activation-success-continue"
          variant="primary"
          className="w-full"
          onClick={() => redirectToUrl(redirectUrl)}
        >
          {formatMessage({ id: 'br_activation.success.continue' })}
        </Button>
      }
    >
      <Typography variant="body" component="p">
        {formatMessage({ id: 'br_activation.success.body' })}
      </Typography>
    </ActivationStepLayout>
    </>
  )
}
